import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      height: 200,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: '#ffffff50',
    },
    title: {
      marginBottom: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: 32,
      },
    },
    subTitle: {
      textAlign: 'center',
    },
  }),
);

export default useStyles;
